<template>
  <a-modal v-model="visible" :footer="null" class="purchase-info" :afterClose="close" :destroyOnClose="true" key="loginFrm" :width="350">
    <div class="title">
      充值提示
    </div>
    <div class="recharge-tip-content" v-if="!accountInfo[tipType]">
      <p>
        您好！该功能需要</br>
        购买会员套餐后方可使用！
      </p>
      <a href="/account/recharge">购买会员套餐
        <a-icon type="caret-right" style="transform: scale(0.7);" /></a>
    </div>
    <div class="recharge-tip-content" v-else>

      <p style="font-size:14px;">
        您好！</br>
        您当日可查数据量已用完，请明日再试！
      </p>
      
      <a @click="visible=false">好的
        <a-icon type="caret-right" style="transform: scale(0.7);" /></a>
      <a href="/account/">进入个人中心
        <a-icon type="caret-right" style="transform: scale(0.7);" /></a>

    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true
    };
  },
  props: {
    close: Function,
    tipType:{
      required:true,
      type:String
    },
    accountInfo:{
      required:true,
      type:Object
    }
  },
  methods: {}
};
</script>
<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";
.purchase-info {
  .ant-modal-body {
    padding: 0;
  }
  .title {
    width: 100%;
    height: 60px;
    padding: 10px 20px;
    font-size: 16px;
    line-height: 40px;
    background-color: #f3f3f3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .recharge-tip-content {
    text-align: center;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    p {
      margin: 40px auto;
      color: #ff6b6b;
      font-size: 18px;
    }
    a {
      margin:0 20px;
      margin-bottom: 20px;
      display:inline-block;
    }
  }
}
</style>
